import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { Select2Module } from 'ng2-select2';
import { ComponentsModule } from '../../../../../components/component.module';
import { RouterModule } from '@angular/router';
import { ExpertComponent } from './expert.component';
import { AgentComponent } from './agent/agent.component';
import { GroupComponent } from './group/group.component';
import { OrganizationComponent } from './organization/organization.component';

@NgModule({
  imports: [BrowserModule, FormsModule, Select2Module, ComponentsModule, RouterModule],
  declarations: [ExpertComponent, AgentComponent, GroupComponent, OrganizationComponent],
  exports: [ExpertComponent],
  providers: [],
})
export class ExpertModule {}



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/setting/expert/expert.module.ts